// extracted by mini-css-extract-plugin
export default {"terms":"VN9bjP6c0NygVSzzbqiY","intro":"wtn3phmWj1EwTpnl7_EA","sections":"LnzXC_YrpkNSFJtnDnZA","content":"FmDDjUP4rFTJwEzBh85i","title":"or4Aaaf2sd9pko_86Hcp"};